import { useRef, useState } from "react";
import { motion } from "framer-motion";
import "./DotArray.css";
import Card from "../Card/Card";
import DotHtmlSnippet from "../../snippets/DotSnippet/DotSnippet";
import { Copy } from "lucide-react";

const DotArraySnippet = () => {
  const snippetContainerRef = useRef(null);
  const [showCopying, setShowCopying] = useState(false);

  const copySnippet = () => {
    if (snippetContainerRef.current) {
      const range = document.createRange();
      range.selectNode(snippetContainerRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      window.getSelection().removeAllRanges();

      setShowCopying(true);
      setTimeout(() => setShowCopying(false), 1000);
    }
  };

  const DotArray = ({ dotsCount = 150 }) => {
    const dotsArray = Array.from({ length: dotsCount });
    return (
      <div className="dots-container" style={{ maxHeight: '40rem', backgroundColor: '#FFF' }}>
        {dotsArray.map((_, i) => (
          <span
            key={i}
            className="dot"
            style={{
              '--x-move': `${Math.random() * 2 - 1}`,
              '--y-move': `${Math.random() * 2 - 1}`,
              '--x-start': `${Math.random() * 100}vw`,
              '--y-start': `${Math.random() * 100}vh`,
            }}
          ></span>
        ))}
      </div>
    );
  };

  return (

    <>
      <DotArray />
      <pre>
        <div className={`center-container ${showCopying ? "scanning" : ""}`}>

          <div className="snippet" ref={snippetContainerRef}>
            <DotHtmlSnippet />
          </div>
          <button aria-label="Copy Button" onClick={copySnippet}>
            <Copy/>
          </button>
        </div>
      </pre>

    </>
  );
};

const DotArray = () => {
  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >

      <Card CardTitle="Dot particles" CardBody={<DotArraySnippet />} />
    </motion.div>
  );
};

DotArray.propTypes = {};

export default DotArray;
